import React from 'react';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightIcon from '@mui/icons-material/Flight';

export const DELIVERY_STANDART = 1;
export const DELIVERY_TOMORROW = 2;
export const DELIVERY_EXPRESS = 3;
export const DELIVERY_TODAY = 4;

export const getCargoAgreementLabel = (shippingCompanyId: number): string => {
    if (shippingCompanyId >= 1 && shippingCompanyId <= 999) {
        return 'LCW Öder';
    }
    if (shippingCompanyId >= 1000) {
        return 'Satıcı Öder';
    }
    return '';
};

export const getDeliveryTypeIcon = (deliveryTypeId: number): React.ReactNode => {
    if (deliveryTypeId === DELIVERY_TODAY) {
        return <RocketLaunchIcon />;
    }
    if (deliveryTypeId === DELIVERY_STANDART) {
        return <FlightIcon />;
    }
    if (deliveryTypeId === DELIVERY_TOMORROW) {
        return <AccessTimeIcon />;
    }
    if (deliveryTypeId === DELIVERY_EXPRESS) {
        return (
            <div>
                <FlightTakeoffIcon />
            </div>
        );
    }
    return <RocketLaunchIcon />;
};
